export default "__VITE_ASSET__d39a722c__"